__turbopack_context__.v({
  "container": "styles-module-scss-module__bUzsHa__container",
  "header": "styles-module-scss-module__bUzsHa__header",
  "inner": "styles-module-scss-module__bUzsHa__inner",
  "inner-option1": "styles-module-scss-module__bUzsHa__inner-option1",
  "textfield-and-button-container": "styles-module-scss-module__bUzsHa__textfield-and-button-container",
  "textfield-and-button-container-option1": "styles-module-scss-module__bUzsHa__textfield-and-button-container-option1",
});
